/*
 * Project: LegalPlace assistant
 * File: src\redux\reducers\lperrors.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/
import { LP_ERROR_SET, LP_ERROR_UNSET } from '../actions/lperrors';


export default function lpErrorReducer(state = {
  code: 0,
  message: '',
  type: 0,
  components: {},
}, action) {
  const result = state;
  switch (action.type) {
    case LP_ERROR_SET: {
      const { error } = action;
      if (error.error_log_type === 0) {
        result.code = action.error.code;
        result.message = action.error.message;
        result.type = action.error.type;
      } else {
        result.components[error.component_type] = {
          code: error.code,
          message: error.message,
          type: error.type,
        };
      }
      break;
    }
    case LP_ERROR_UNSET:
      if (action.component === 'global') {
        result.code = 0;
        result.message = '';
        result.type = 0;
      } else {
        result.components[action.component] = undefined;
      }
      break;
    default:
      return state;
  }
  return result;
}



// WEBPACK FOOTER //
// ./src/redux/reducers/lperrors.js